"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var MainVA = function (_a) {
    var type = _a.type, width = _a.width, height = _a.height, fill = _a.fill;
    switch (type) {
        case 'line':
        default:
            return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
                React.createElement("path", { fill: fill, fillRule: "evenodd", clipRule: "evenodd", d: "M21.975 6.36365C19.2915 6.36365 17.1161 8.53907 17.1161 11.2226V34.5455H21.975V11.2226V6.36365ZM13.229 25.7994V20.9405C10.5454 20.9405 8.37003 23.1159 8.37003 25.7994L8.37003 34.5455H13.229V25.7994ZM30.7211 13.1662V18.0251V34.5455H25.8622V18.0251C25.8622 15.3416 28.0376 13.1662 30.7211 13.1662Z" })));
    }
};
MainVA.propTypes = {
    type: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
};
MainVA.defaultProps = {
    type: 'solid',
    width: 40,
    height: 40,
    fill: colors_1.grey5,
};
exports.default = MainVA;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFpblZBLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ljb25zL01haW5WQS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2QkFBK0I7QUFDL0Isc0NBQXdDO0FBRXhDLG9DQUFnQztBQVFoQyxJQUFNLE1BQU0sR0FBMEIsVUFBQyxFQUEyQjtRQUExQixjQUFJLEVBQUUsZ0JBQUssRUFBRSxrQkFBTSxFQUFFLGNBQUk7SUFDL0QsUUFBUSxJQUFJLEVBQUU7UUFDWixLQUFLLE1BQU0sQ0FBQztRQUNaO1lBQ0UsT0FBTyxDQUNMLDZCQUFLLEtBQUssRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUMsV0FBVyxFQUFDLElBQUksRUFBQyxNQUFNO2dCQUNoRSw4QkFDRSxJQUFJLEVBQUUsSUFBSSxFQUNWLFFBQVEsRUFBQyxTQUFTLEVBQ2xCLFFBQVEsRUFBQyxTQUFTLEVBQ2xCLENBQUMsRUFBQyx5U0FBeVMsR0FDM1MsQ0FDRSxDQUNQLENBQUM7S0FDTDtBQUNILENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxTQUFTLEdBQUc7SUFDakIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFhO0lBQzdCLEtBQUssRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsTUFBTSxDQUFDLENBQVE7SUFDdkUsTUFBTSxFQUFFLFNBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBUTtJQUN4RSxJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07Q0FDdkIsQ0FBQztBQUVGLE1BQU0sQ0FBQyxZQUFZLEdBQUc7SUFDcEIsSUFBSSxFQUFFLE9BQU87SUFDYixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRSxFQUFFO0lBQ1YsSUFBSSxFQUFFLGNBQUs7Q0FDWixDQUFDO0FBRUYsa0JBQWUsTUFBTSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/MainVA.js
// module id = 79
// module chunks = 0